import React from 'react';
import GeneralChart from '@/components/seo/GeneralChart';
import { JobTitleContext } from '@/context/create-context';

const RecruitmentIndustry = (props: {
  id: string;
  industryData: Record<string, any>;
}) => {
  const { id, industryData } = props;
  const industryMarketContent: string[] = industryData?.['市场解读'] || [];

  const { isJobTitleCity } = React.useContext(JobTitleContext);

  return (
    <GeneralChart id={id} title="不同行业的需求分析" tip={industryData['tip']}>
      <p className="mb-2">
        {industryData['总结']?.[isJobTitleCity ? '城市趋势' : '全国趋势'] || ''}
      </p>
      {!!industryMarketContent.length && (
        <>
          <p className="font-semibold mb-2">市场解读</p>
          <ul className="list-inside !ml-2 mb-2">
            {industryMarketContent.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </>
      )}
    </GeneralChart>
  );
};

export default RecruitmentIndustry;
